import { registerSystem } from "yage/components/ComponentRegistry";
import { System } from "yage/components/System";
import { ComponentCategory } from "yage/constants/enums";
import { Component, Schema, defaultValue, type } from "yage/decorators/type";
import { GameModel } from "yage/game/GameModel";
import { NegateDamageSchema } from "../damagemods/NegateDamage";
import { PlayerTypeSchema, EnemyTypeSchema } from "yage/components/entity/Types";
import { ChildSchema } from "yage/schemas/entity/Child";

@Component("NegateDamageEnhancer")
export class NegateDamageEnhancerSchema extends Schema {
  @type("number")
  @defaultValue(1)
  negateCount: number;
}

class NegateDamageEnhancerSystem implements System {
  schema = NegateDamageEnhancerSchema;
  type = "NegateDamageEnhancer";
  category = ComponentCategory.ONDAMAGE;

  dependencies = ["Child"];
  init(entity: number, gameModel: GameModel) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (!gameModel.hasComponent(parent, "NegateDamage")) {
        gameModel.addComponent(parent, NegateDamageSchema);
      }
      gameModel.getTypedUnsafe(parent, NegateDamageSchema).negateCount += gameModel.getTypedUnsafe(
        entity,
        NegateDamageEnhancerSchema
      ).negateCount;
    }
  }

  cleanup(entity: number, gameModel: GameModel, ejecting: boolean) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (gameModel.hasComponent(parent, "NegateDamage")) {
        gameModel.getTypedUnsafe(parent, NegateDamageSchema).negateCount -= gameModel.getTypedUnsafe(
          entity,
          NegateDamageEnhancerSchema
        ).negateCount;
      }
    }
  }
}

registerSystem(NegateDamageEnhancerSystem);
